import { observable, action, runInAction } from 'mobx'
import {get, json} from '../../../utils/ajax'
import {handleSearchAndPage, setStore, ValueObjToObj, objToValueObj, getBeforeDay, downLoad} from '../../../utils/Utils'
import moment from "moment";
import {message} from "antd";

class salesStore {
    @observable loading  //列表loading
    @observable searchField    //搜索表单绑值
    @observable pagination //列表分页
    @observable salesList  //列表数据
    @observable detailedFields  //详看详情模态框字段
    @observable salesModal  //详看详情模态框显示属性
    @observable carseriesNameList  //车系
    @observable timeExportModal //时间导出模态框
    @observable informationModal //查看详情模态框
    @observable multipleSelectedRows//多个选定行
    @observable addFields//新增模态框字段
    @observable addVisible//新增模态框
    @observable vinSearchFields //查看vin查询条件
    @observable vinPagination
    @observable vinList
    @observable vinModal
    @observable vin


    constructor() {
        this.loading = false
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper:true,
            showSizeChanger:true,
            pageSize:20,
            showTotal:()=>{}
        }
        this.salesList = []
        this.searchField = {
            carMaterialCode:'',
            colorName:'',
            orderCode:'',
            carSeriesCode:'',
            optional:'',
            config:'',
            rangePicker:[],
            factoryName:'',
            errorCount:'',
            vin:''
        }
        this.salesModal = false
        this.detailedFields = {
            carMaterialCode:'',
            factoryCode:'',
            dimension:'',
            materialGroup:'',
            createTime:'',
            carSeriesCode:'',
            colorName:'',
            optional:'',
            orderCode:'',
            configDescription:'',
            carMaterialName:'',
            deliveringPlant:'',
            notificationNumber:'',
            materialDescription:'',
            haltProduction:'',
            displacement:'',
            colorDescription:'',
            optionalDescription:'',
            config:''
        }
        this.carseriesNameList=[]
        this.timeExportModal = false
        this.informationModal = false
        this.multipleSelectedRows = []
        this.addFields = {
            vin:'',
            carMaterialCode:'',
            selfMadeDate:''
        }
        this.addVisible = false
        this.vinSearchFields= {
            materialName: '',
            materialNo: '',
            vin : ''
        }
        this.vinPagination= {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 10,
            showTotal: () => {
            }
        }
        this.vinList=[]
        this.vinModal=false
        this.vin=''
    }

    /***搜索框车系数据 ***/
    @action
    initCarseries = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epc/carseries:search`)
        runInAction(() => {
            this.carseriesNameList = Array.isArray(res) ? res : []
        })
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /*** 主页面请求接口加载数据**/
    @action
    initPage = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        let searchField = {
            carMaterialCode:this.searchField.carMaterialCode ? this.searchField.carMaterialCode :'',
            vin:this.searchField.vin ? this.searchField.vin :'',
            instantiateCarMaterialCode:this.searchField.instantiateCarMaterialCode ? this.searchField.instantiateCarMaterialCode :''
        };
        let search = handleSearchAndPage(page, this.pagination,searchField)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/saleserp/getsales:search`,search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.salesList = res.content || []
            this.loading = false
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper:true,
                showSizeChanger:true,
                pageSize:res.size,
                showTotal:()=>`总共 ${res.totalElements} 条`
            }
        })
    }


    /***搜索表单绑值**/
    @action
    onSearchField = (changedFields) => {
        this.searchField = {...this.searchField, ...ValueObjToObj(changedFields)}
    }


    /*** 清空搜索框*/
    @action
    clearForm = () => {
        this.searchField = {
            carMaterialCode:'',
            colorName:'',
            orderCode:'',
            carSeriesCode:'',
            optional:'',
            config:'',
            rangePicker:[],
            errorCount:'',
            vin:''
        }
        this.initPage()
    }

    /**
     * 控制查看详细model弹窗
     * @param clear
     */
    @action
    showSalesModal=(record)=>{
            this.detailedFields = objToValueObj({
                ...record,
                createTime:moment(record.createTime).format("YYYY-MM-DD")
            })
        this.informationModal = true
    }

    /**
     * 重新验证vin
     * @param record
     * @returns {Promise<void>}
     */
    @action
    reconfirm = async (record)=>{
        await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/salesErp/update/vin/${record.id}/${record.vin}`)
        this.initPage(this.pagination.current)
    }

    /**
     * 重置问题数据
     * @param record
     * @returns {Promise<void>}
     */
    @action
    resetProblemData = async ()=>{
        runInAction(() => {
            this.loading = true
        })
        await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/saleserp/resetProblemData`)
        runInAction(() => {
            this.loading = false
            message.success('重置成功')
        })
        this.initPage(this.pagination.current)
    }

    /***绑定新增、编辑表单值，回显验证规则**/
    @action
    onFormDisplayValue = (changeFields, fields) => {
        this[fields] = {...this[fields], ...changeFields}
    }

    /***保存新增**/
    @action
    saveAddModal = async (content) => {
        console.log(content)
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService//saleserp/insert`, content)
            if (res.status !== 0) {
                runInAction(() => {
                    this.addVisible = false
                })
                message.success('新增成功')
                this.initPage(this.pagination.current)
            }
    }


    /**
     * 查看组件
     * @returns {Promise.<void>}
     */
    @action
    showVinModal = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        this.vinSearchFields={...this.vinSearchFields,vin:this.vin}
        let searchResult = handleSearchAndPage(page, this.vinPagination, this.vinSearchFields);
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/produceMesVinPart/queryPartInformationListByMapForPage:search`, searchResult);
        runInAction(() => {
            this.vinList = res.content || [];
            this.vinModal= true
            this.vinPagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共${res.totalElements}条`
            };
            this.loading = false
        })
    };

    /***搜索表单绑值**/
    @action
    onVinSearchField = (changedFields) => {
        this.vinSearchFields = {...this.vinSearchFields, ...ValueObjToObj(changedFields)}
    }

    /*** 清空搜索框*/
    @action
    clearVinForm = () => {
        this.vinSearchFields = {
            materialName:'',
            materialNo:'',
            vin:''
        }
    }

    @action
    vinUrlExport=()=>{
        downLoad(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/produceMesVinPart/exportThePartInformationByVIN?vin=${this.vin}`, `VIN导出零件信息-${this.vin}.xls`)
    }

}

export default new salesStore()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/Sales/store.js